import moment from 'moment';
import { IIncomeInvoicePartResourceShortProps, IIncomeInvoicePartResourceProps } from '../../../../props/finance/incomes/invoices/part';
import { IPaginationResourceShort } from '../../../../props/general';
import Request from './../../../request';

// import props

const IncomeInvoicePartService = {
    download: async (invoiceId: string, partId: string, format?: string, name?: string): Promise<any> => {
        try {
            const result = await Request.download(`/api/incomes/invoices/${invoiceId}/parts/${partId}/download?format=${format ?? 'docx'}`);

            const data = new Blob([result.data], { type: result.headers["content-type"] });
            const url = window.URL.createObjectURL(data);
            const linkTag = document.createElement('a');
            linkTag.href = url;
            linkTag.setAttribute('download', `Invoice ${(name || moment().format("DDMMYYYY"))}.${format ?? 'docx'}`);
            linkTag.click();

            return result;
        } catch (e) {
            throw (e);
        }
    },
    retrieve: async (invoiceId?: string, qs?: string): Promise<{ data: IIncomeInvoicePartResourceShortProps[], pagination: IPaginationResourceShort }> => {
        try {
            if (invoiceId) {
                const result = await Request.get(`/api/incomes/invoices/${invoiceId}/parts?${qs || ""}`);
                return result;
            } else {
                const result = await Request.get(`/api/incomes/invoices/parts?${qs || ""}`);
                return result;
            }
        } catch (e) {
            throw (e);
        }
    },
    get: async (invoiceId: string, partId: string): Promise<IIncomeInvoicePartResourceProps> => {
        try {
            const result = await Request.get(`/api/incomes/invoices/${invoiceId}/parts/${partId}`);
            return result;
        } catch (e) {
            throw (e);
        }
    },
    create: async (invoiceId: string, data: FormData): Promise<IIncomeInvoicePartResourceProps> => {
        try {
            const result = await Request.post(`/api/incomes/invoices/${invoiceId}/parts`, data, 'multipart/form-data');
            return result;
        } catch (e) {
            throw (e);
        }
    },
    update: async (invoiceId: string, partId: string, data: FormData): Promise<IIncomeInvoicePartResourceProps> => {
        try {
            const result = await Request.post(`/api/incomes/invoices/${invoiceId}/parts/${partId}`, data, 'multipart/form-data');
            return result;
        } catch (e) {
            throw (e);
        }
    },
    delete: async (invoiceId: string, partId: string): Promise<void> => {
        try {
            await Request.delete(`/api/incomes/invoices/${invoiceId}/parts/${partId}`);
            return;
        } catch (e) {
            throw (e);
        }
    }
}

export default IncomeInvoicePartService;